import Echo from "laravel-echo/dist/echo";
import socketio from "socket.io-client";

const echo = new Echo({
  host: "https://live-posts.3news.com:6001",
  broadcaster: "socket.io",
});

export default echo;
